import React from 'react';
import {createRoot} from 'react-dom/client';

import reportWebVitals from './reportWebVitals';
import './index.css';
import {Root} from './core/Root';

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);
root.render(<Root />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
